import { reportMykissError } from '../../../../../../../helpers/errorHandling';

const EXTRA_MESSAGE =
  'If you used Google, Apple or Facebook to create your account, please refer to the buttons below.';

export const handleStandardAuthError = (error: any, invalidLoginAttempts = 0): string => {
  if (error && 'code' in error) {
    if (error.code === 'UserNotFoundException' || error.code === 'NotAuthorizedException') {
      const errorMessage = 'The email and password did not match. Please try again.';
      return invalidLoginAttempts > 1 ? `${errorMessage} ${EXTRA_MESSAGE}` : errorMessage;
    }

    reportMykissError(error);
    return error.message;
  }
  reportMykissError(error);

  return 'Something went wrong, please contact support if the issue continues.';
};
